import React, { createContext, useContext, useReducer, ReactNode } from 'react';
import { Input, DollarValues } from './types'; // Adjust the import path as needed

// Define the shape of your context state
interface FlowState {
    dollarValues: DollarValues;
    // Add other state properties here as needed
}

// Initial state
const initialState: FlowState = {
    dollarValues: {},
};

// Actions types
type Action =
    | { type: 'SET_DOLLAR_VALUES'; payload: DollarValues }
    // Add other action types here

// Context creation
const FlowContext = createContext<{
    state: FlowState;
    dispatch: React.Dispatch<Action>;
}>({
    state: initialState,
    dispatch: () => null, // Placeholder function
});

// Reducer function to handle state changes
const flowReducer = (state: FlowState, action: Action): FlowState => {
    switch (action.type) {
        case 'SET_DOLLAR_VALUES':
            return { ...state, dollarValues: action.payload };
        // Handle other actions here
        default:
            return state;
    }
};

// Define a type for the props expected by FlowProvider
interface FlowProviderProps {
    children: ReactNode;
}

// Context Provider component
export const FlowProvider: React.FC<FlowProviderProps> = ({ children }) => {
    const [state, dispatch] = useReducer(flowReducer, initialState);

    return (
        <FlowContext.Provider value={{ state, dispatch }}>
            {children}
        </FlowContext.Provider>
    );
};

// Custom hook to use the flow context
export const useFlowContext = () => useContext(FlowContext);
